import Notification from "@/services/echo-manager/notification";

export default class ApplicationReceived extends Notification
{
    handle() {
        //
    }
}